import { CourseChapter, CourseChapterSection } from "@remar/shared/dist/models";

import { DraggableSrcInterface } from "./types";

interface ReorderSectionLessonArg {
	startSrc: DraggableSrcInterface;
	endSrc: DraggableSrcInterface;
	sections: CourseChapterSection[];
}

export const computeReorder = (
	info: ReorderSectionLessonArg
): { newOrder: CourseChapterSection[]; selectedLesson: CourseChapterSection } => {
	const { startSrc, sections, endSrc } = info;

	const _section = [...sections];
	let selectedLesson;
	const newOrder = _section.map(el => {
		if (el.id === Number(startSrc.droppableId)) {
			const sortedLessons = el.sectionLessons!.concat().sort((a, b) => a.order - b.order);
			const [removed] = sortedLessons.splice(startSrc.index, 1);
			selectedLesson = removed;
			sortedLessons.splice(endSrc.index, 0, removed);
			const updatedOrderLessons = sortedLessons.map((lesson, index) => {
				return { ...lesson, order: index };
			});
			return { ...el, sectionLessons: updatedOrderLessons };
		} else {
			return el;
		}
	});
	return { newOrder, selectedLesson };
};

export const reorderChapters = (
	chapters: CourseChapter[],
	swapTo: { index: number },
	swapFrom: { index: number }
): { reorderedChapters: CourseChapter[]; selectedChapterId: number } => {
	const reorderedChapters = [...chapters];
	const selectedChapterId = reorderedChapters[swapFrom.index]?.id;
	const [removed] = reorderedChapters.splice(swapFrom.index, 1);
	const newOrder = swapTo.index > swapFrom.index ? chapters[swapTo.index].order + 1 : chapters[swapTo.index].order;
	reorderedChapters.splice(swapTo.index, 0, { ...removed, order: newOrder });
	const updatedOrderChapters = reorderedChapters.map((chapter, index) => {
		return { ...chapter, order: index };
	});
	return { reorderedChapters: updatedOrderChapters, selectedChapterId: selectedChapterId as number };
};
